import { useContext, useState } from "react";
import UserContext from "../context/UserContext";

const LoginComponent = () => {
  const [mensajeError] = useState("Usuario o contraseña incorrectos");
  const { loginError, LoginWithGoogle } = useContext(UserContext);

  return (
    <div className="mx-auto mt-6 w-full max-w-md rounded-2xl border border-white/10 bg-slate-900/80 p-6 shadow-2xl shadow-black/20">
      <h2 className="mb-3 text-center text-2xl font-semibold text-white">
        Iniciar Sesión
      </h2>
      {loginError && (
        <div className="my-3 rounded-lg border border-rose-400/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-200">
          {mensajeError}
        </div>
      )}
      <button
        onClick={LoginWithGoogle}
        className="flex w-full items-center justify-center gap-3 rounded-xl border border-slate-700 bg-slate-800 px-4 py-3 font-medium text-slate-100 transition hover:bg-slate-700"
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          width={20}
          alt="Google"
        />
        Continuar con Google
      </button>
    </div>
  );
};

export default LoginComponent;
